import { render, staticRenderFns } from "./SmsCustomAction.vue?vue&type=template&id=5a2bc6c8&scoped=true&"
import script from "./SmsCustomAction.vue?vue&type=script&lang=js&"
export * from "./SmsCustomAction.vue?vue&type=script&lang=js&"
import style0 from "./SmsCustomAction.vue?vue&type=style&index=0&id=5a2bc6c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2bc6c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a2bc6c8')) {
      api.createRecord('5a2bc6c8', component.options)
    } else {
      api.reload('5a2bc6c8', component.options)
    }
    module.hot.accept("./SmsCustomAction.vue?vue&type=template&id=5a2bc6c8&scoped=true&", function () {
      api.rerender('5a2bc6c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/CustomActions/Sms/SmsCustomAction.vue"
export default component.exports